var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-preview"},[_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"src":`${_vm.widgetUrl}/?bot_id=${_vm.botId}`,"width":"400","height":"100%","frameBorder":"0","id":"widger-iframe-preview"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }